import { ISavingPropositionFund } from "@portal/types/robot/ISavingPropositionFund";

interface CustomGraphFund {
  name: string;
  y: number;
  color: string;
}

/**
 * Component to provide data for the chart for the saving suggestion page.
 * @param propositionFunds
 * @returns an object with chart data.
 */
export const SavingSuggestionData = (propositionFunds: ISavingPropositionFund[] | undefined) => {
  const propositionFundData = [] as CustomGraphFund[];
  const combinationFundData = [] as CustomGraphFund[];

  propositionFunds?.forEach((fund, i) => {
    propositionFundData.push({
      name: fund.name,
      y: fund.percentageOfTotal,
      color: GetColor(i),
    });
  });

  propositionFunds?.forEach((fund, i) => {
    if (!fund.combinationChildFunds.length) {
      combinationFundData.push({ name: fund.name, y: fund.percentageOfTotal, color: GetColor(i) });
    } else {
      fund.combinationChildFunds.forEach(cf => {
        combinationFundData.push({ name: cf.name, y: cf.percentageOfTotal, color: GetColor(i) });
      });
    }
  });

  return {
    chart: { type: "pie" },
    credits: { enabled: false },
    title: null,
    accessibility: { enabled: false },
    legend: { itemStyle: { fontSize: "12px" }, redraw: true },
    plotOptions: { pie: { shadow: false, dataLabels: { enabled: false }, innerSize: "100%", borderWidth: 2 } },
    tooltip: { pointFormat: "<b>{point.percentage:.1f}%</b>" },
    series: [
      {
        innerSize: "40%",
        size: 280,
        data: propositionFundData,
        showInLegend: true,
      },
      {
        innerSize: "35%",
        size: 240,
        data: combinationFundData,
      },
    ],
  };
};

function GetColor(index: number) {
  if (index === 0) return "#50c878";
  if (index === 1) return "#EF9224";
  if (index === 2) return "#7CB5EC";
  if (index === 3) return "#e0a507";
  if (index === 4) return "#f2ede9";
  return "#50c878";
}
